const ApiAddress = `https://voxa-node.onrender.com`

export default ApiAddress